import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { TypeOfBusinessJson } from "../../../DynamicFormsJson/MastersJSON/typeOfBusiness";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
class TypeOfBusinesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
      },
    };
  }

  render() {
    return (
      <>
        <DynamicForm
          formPath={TypeOfBusinessJson.formPath}
          screenTitle={TypeOfBusinessJson.screenTitle}
          fieldMeta={TypeOfBusinessJson.fieldMeta}
          apiBaseURL={TypeOfBusinessJson.apiBaseURL}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({

});
const mapDispatchToProps = {
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(TypeOfBusinesForm);
